module.exports = __webpack_public_path__ + "img/20190806162746QQ截图20190806023721.fa85b7a9.png";